export default __webpack_public_path__ + "b14b42ad2a9da8363121413d7dee0954.jpg";